
<svg class="icon-arrow" xmlns="http://www.w3.org/2000/svg" width="22" height="10" viewBox="0 0 22 10" fill="none">
  <path
    d="M21.3524 4.64747L17.3524 0.647473C17.0384 0.333482 16.5016 0.555863 16.5016 0.999913V3.99991H1C0.447715 3.99991 0 4.44763 0 4.99991C0 5.5522 0.447715 5.99991 1 5.99991H16.5016V8.99991C16.5016 9.44396 17.0384 9.66634 17.3524 9.35235L21.3524 5.35235C21.5471 5.15771 21.5471 4.84212 21.3524 4.64747Z"
    fill="#BB0049"
  />
</svg>
